import { FormikHelpers } from "formik";
import { toast } from "react-toastify";
import { AddAssetCategoryInitialValues } from "./FormikValidation";
import { api } from "../../../../../../Api/Api";
import { setValidationErrors } from "../../../../../../Utils/helpers/helpers";

type AddInitialValues = {
  name: string;
  document: boolean;
};

export const StaffSubmitHandler = (
  values: AddInitialValues,
  actions: FormikHelpers<AddInitialValues>,
  setIsOpen: Function,
  refetch: Function,
  editMode: boolean,
  id: string | number,
  cat_id: any
) => {
  // Add
  if (editMode) {
    api
      .patch(
        `/assets-categories/${id}`,
        {
          name: values?.name,
          parent_id: cat_id,
          document_status: values?.document === true ? 1 : 2
        },
        true
      )
      .then(async function ([success, response]: any) {
        toast.success("Asset Subcategories Details Updated ");
        setIsOpen(false);
        refetch();
      })
      .catch((err) => {
        actions?.setSubmitting(false);
        if (err?.response?.data?.errors) {
          setValidationErrors(err?.response?.data?.errors, actions);
        } else {
          toast.error("Unexpected Error Occurred");
        }
      });
  }
  // Edit
  else {
    api
      .post(
        "/assets-categories",
        {
          name: values?.name,
          parent_id: cat_id,
          document_status: values?.document === true ? 1 : 2
        },
        true
      )
      .then(async function ([success, response]: any) {
        toast.success("Asset Subcategories Added ");
        setIsOpen(false);
        refetch();
      })
      .catch((err) => {
        actions?.setSubmitting(false);
        if (err?.response?.data?.errors) {
          setValidationErrors(err?.response?.data?.errors, actions);
        } else {
          toast.error("Unexpected Error Occurred");
        }
      });
  }
};

// extract Departmentdata for table
export const extractStaffData = (data: any) => {
  const res = data?.data?.map((item: any) => {
    return {
      id: item?.id,
      category: item?.parent?.name,
      name: item?.name,
    };
  });
  return res;
};

// initializing add Department form - Edit / add
export const addModalInitialValuesHandler = (
  modalEditData: any,
  setAddModalInitialValues: Function,
  setEditMode: Function
) => {
  if (modalEditData?.length !== 0) {
    setEditMode(true);
    setAddModalInitialValues({
      id: modalEditData?.[0]?.id,
      name: modalEditData?.[0]?.name,
      document: modalEditData?.[0]?.document_status === 1
    });
  } else {
    setEditMode(false);
    setAddModalInitialValues(AddAssetCategoryInitialValues);
  }
};

// Department table edit onclick trigger
export const onEditClickHandler = (
  selectedId: any,
  setModalEditData: Function,
  setIsOpen: Function,
  doctorData: any
) => {
  setModalEditData([]);
  setModalEditData(
    doctorData?.data?.filter((itm: any) => itm?.id === selectedId)
  );

  setIsOpen(true);
};

// add Department open / close
export const modalHandler = (
  setModalEditData: Function,
  setIsOpen: Function
) => {
  setModalEditData([]);
  setIsOpen(true);
};

// Department delete
export const deleteClickHandler = (
  selectedId: string | number,
  refetch: Function
) => {
  api
    .delete(`/assets-categorie/${selectedId}`, {}, true)
    .then(async function ([success, response]: any) {
      refetch();
      toast.success("Deleted");
    })
    .catch((err) => {
      toast.error("Unexpected Error Occurred");
    });
};

export const setCurrentPageStaff = (navigate: Function, id: any, pathname: string) => {
  if (pathname?.startsWith("/member")) {
    navigate(`/member/asset-sub-category-settings/${id}`)
  }
  if (pathname?.startsWith("/admin")) {
    navigate(`/admin/asset-sub-category-settings/${id}`)
  }
};
